/*nodejs-versions*/
/*operating-systems-architecture-and-other-arbitrary-conditions*/
/*write-an-arbitrary-file-to-disk*/
/*add-the-file-to-your-gitignore*/
/*add-the-file-to-the-hash*/
/*generate-the-file-before-running-turbo*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "处理平台",
  "description": "了解如何处理 Turborepo 任务中与操作系统、架构和其他任意条件相关的缓存。"
};
export let structuredData = {
  "contents": [{
    "heading": "nodejs-版本-nodejs-versions",
    "content": "¥Node.js versions"
  }, {
    "heading": "nodejs-版本-nodejs-versions",
    "content": "为了兼容 Node.js 版本，请使用 package.json 中的 engine 键。Turborepo 会记录此字段的更改，并相应地缓存丢失。"
  }, {
    "heading": "nodejs-版本-nodejs-versions",
    "content": "¥To account for Node.js versions, use the engines key in package.json. Turborepo will account for changes to this field and miss cache accordingly."
  }, {
    "heading": "操作系统架构和其他任意条件-operating-systems-architecture-and-other-arbitrary-conditions",
    "content": "¥Operating systems, architecture, and other arbitrary conditions"
  }, {
    "heading": "操作系统架构和其他任意条件-operating-systems-architecture-and-other-arbitrary-conditions",
    "content": "对于高级用例，你可能希望操作系统 (OS)、架构或其他外部因素影响你的哈希值。"
  }, {
    "heading": "操作系统架构和其他任意条件-operating-systems-architecture-and-other-arbitrary-conditions",
    "content": "¥For advanced use cases, you may want the operating system (OS), architecture, or other external factors to contribute to your hash."
  }, {
    "heading": "1-将任意文件写入磁盘-write-an-arbitrary-file-to-disk",
    "content": "¥ Write an arbitrary file to disk"
  }, {
    "heading": "1-将任意文件写入磁盘-write-an-arbitrary-file-to-disk",
    "content": "首先，创建一个脚本，用于记录你感兴趣的哈希值贡献者。例如，以下是一段 Node.js 脚本，用于识别平台和架构，并将这些详细信息写入文件 (turbo-cache-key.json)："
  }, {
    "heading": "1-将任意文件写入磁盘-write-an-arbitrary-file-to-disk",
    "content": "¥First, create a script that accounts for the hash contributors that you are interested in. For example, here is a Node.js script that identifies platform and architecture and writes those details to a file (turbo-cache-key.json):"
  }, {
    "heading": "2-将文件添加到你的-gitignore-文件-add-the-file-to-your-gitignore",
    "content": "¥ Add the file to your .gitignore"
  }, {
    "heading": "2-将文件添加到你的-gitignore-文件-add-the-file-to-your-gitignore",
    "content": "由于此文件依赖于环境，因此你不需要将其提交到源代码管理。将其添加到你的 .gitignore："
  }, {
    "heading": "2-将文件添加到你的-gitignore-文件-add-the-file-to-your-gitignore",
    "content": "¥You won't want to commit this file to source control since it's dependent on environment. Add it to your .gitignore:"
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "¥ Add the file to the hash"
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "现在，通过将文件添加到任务输入中，确保 turbo 知道该文件。你可以通过两种方式执行此操作："
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "¥Now, make sure that turbo is aware of the file by adding it to task inputs. You can do this two ways:"
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "对于特定任务：在任务的 inputs 数组 中包含该文件："
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "¥For specific tasks: Include the file in the inputs array of the task(s):"
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "对于所有任务：将文件添加到 globalDependencies"
  }, {
    "heading": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "¥For all tasks: Add the file to globalDependencies"
  }, {
    "heading": "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
    "content": "¥ Generate the file before running turbo"
  }, {
    "heading": "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
    "content": "最后，你需要确保在运行 turbo 之前运行该脚本。例如："
  }, {
    "heading": "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
    "content": "¥Last, you'll want to ensure that you run the script before running turbo. For example:"
  }, {
    "heading": "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
    "content": "turbo run build 现在将在计算 build 任务的哈希值时考虑 turbo-cache-key.json 的内容。"
  }, {
    "heading": "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
    "content": "¥turbo run build will now take into account the contents of turbo-cache-key.json when calculating the hash for the build task."
  }],
  "headings": [{
    "id": "nodejs-版本-nodejs-versions",
    "content": "Node.js 版本 /*nodejs-versions*/"
  }, {
    "id": "操作系统架构和其他任意条件-operating-systems-architecture-and-other-arbitrary-conditions",
    "content": "操作系统、架构和其他任意条件 /*operating-systems-architecture-and-other-arbitrary-conditions*/"
  }, {
    "id": "1-将任意文件写入磁盘-write-an-arbitrary-file-to-disk",
    "content": "1. 将任意文件写入磁盘 /*write-an-arbitrary-file-to-disk*/"
  }, {
    "id": "2-将文件添加到你的-gitignore-文件-add-the-file-to-your-gitignore",
    "content": "2. 将文件添加到你的 .gitignore 文件 /*add-the-file-to-your-gitignore*/"
  }, {
    "id": "3-将文件添加到哈希值-add-the-file-to-the-hash",
    "content": "3. 将文件添加到哈希值 /*add-the-file-to-the-hash*/"
  }, {
    "id": "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
    "content": "4. 运行 turbo 之前生成文件 /*generate-the-file-before-running-turbo*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#nodejs-版本-nodejs-versions",
  title: _jsx(_Fragment, {
    children: "Node.js 版本 "
  })
}, {
  depth: 2,
  url: "#操作系统架构和其他任意条件-operating-systems-architecture-and-other-arbitrary-conditions",
  title: _jsx(_Fragment, {
    children: "操作系统、架构和其他任意条件 "
  })
}, {
  depth: 3,
  url: "#1-将任意文件写入磁盘-write-an-arbitrary-file-to-disk",
  title: _jsx(_Fragment, {
    children: "1. 将任意文件写入磁盘 "
  })
}, {
  depth: 3,
  url: "#2-将文件添加到你的-gitignore-文件-add-the-file-to-your-gitignore",
  title: _jsx(_Fragment, {
    children: "2. 将文件添加到你的 .gitignore 文件 "
  })
}, {
  depth: 3,
  url: "#3-将文件添加到哈希值-add-the-file-to-the-hash",
  title: _jsx(_Fragment, {
    children: "3. 将文件添加到哈希值 "
  })
}, {
  depth: 3,
  url: "#4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
  title: _jsxs(_Fragment, {
    children: ["4. 运行 ", _jsx("code", {
      children: "turbo"
    }), " 之前生成文件 "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "nodejs-版本-nodejs-versions",
      children: "Node.js 版本 "
    }), "\n", _jsx(_components.p, {
      children: "¥Node.js versions"
    }), "\n", _jsxs(_components.p, {
      children: ["为了兼容 Node.js 版本，请使用 ", _jsx(_components.a, {
        href: "https://npm.nodejs.cn/cli/v10/configuring-npm/package-json#engines",
        children: "package.json 中的 engine 键"
      }), "。Turborepo 会记录此字段的更改，并相应地缓存丢失。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To account for Node.js versions, use ", _jsx(_components.a, {
        href: "https://npm.nodejs.cn/cli/v10/configuring-npm/package-json#engines",
        children: "the engines key in package.json"
      }), ". Turborepo will account for changes to this field and miss cache accordingly."]
    }), "\n", _jsx(_components.h2, {
      id: "操作系统架构和其他任意条件-operating-systems-architecture-and-other-arbitrary-conditions",
      children: "操作系统、架构和其他任意条件 "
    }), "\n", _jsx(_components.p, {
      children: "¥Operating systems, architecture, and other arbitrary conditions"
    }), "\n", _jsx(_components.p, {
      children: "对于高级用例，你可能希望操作系统 (OS)、架构或其他外部因素影响你的哈希值。"
    }), "\n", _jsx(_components.p, {
      children: "¥For advanced use cases, you may want the operating system (OS), architecture, or other external factors to contribute to your hash."
    }), "\n", _jsx(_components.h3, {
      id: "1-将任意文件写入磁盘-write-an-arbitrary-file-to-disk",
      children: "1. 将任意文件写入磁盘 "
    }), "\n", _jsx(_components.p, {
      children: "¥ Write an arbitrary file to disk"
    }), "\n", _jsxs(_components.p, {
      children: ["首先，创建一个脚本，用于记录你感兴趣的哈希值贡献者。例如，以下是一段 Node.js 脚本，用于识别平台和架构，并将这些详细信息写入文件 (", _jsx(_components.code, {
        children: "turbo-cache-key.json"
      }), ")："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥First, create a script that accounts for the hash contributors that you are interested in. For example, here is a Node.js script that identifies platform and architecture and writes those details to a file (", _jsx(_components.code, {
        children: "turbo-cache-key.json"
      }), "):"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./scripts/create-turbo-cache-key.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "#!/usr/bin/env node"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "writeFileSync"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " require"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'fs'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ");"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "join"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " require"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'path'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ");"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "platform"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " arch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " process;"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " file"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'turbo-cache-key.json'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " str"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " JSON"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".stringify"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "({ platform"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " arch });"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "console"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".log"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "`Generating cache key: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "${"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "str"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "`"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ");"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "writeFileSync"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "(file"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " str);"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "2-将文件添加到你的-gitignore-文件-add-the-file-to-your-gitignore",
      children: "2. 将文件添加到你的 .gitignore 文件 "
    }), "\n", _jsx(_components.p, {
      children: "¥ Add the file to your .gitignore"
    }), "\n", _jsxs(_components.p, {
      children: ["由于此文件依赖于环境，因此你不需要将其提交到源代码管理。将其添加到你的 ", _jsx(_components.code, {
        children: ".gitignore"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You won't want to commit this file to source control since it's dependent on environment. Add it to your ", _jsx(_components.code, {
        children: ".gitignore"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".gitignore",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ turbo-cache-key.json"
            })
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "3-将文件添加到哈希值-add-the-file-to-the-hash",
      children: "3. 将文件添加到哈希值 "
    }), "\n", _jsx(_components.p, {
      children: "¥ Add the file to the hash"
    }), "\n", _jsxs(_components.p, {
      children: ["现在，通过将文件添加到任务输入中，确保 ", _jsx(_components.code, {
        children: "turbo"
      }), " 知道该文件。你可以通过两种方式执行此操作："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now, make sure that ", _jsx(_components.code, {
        children: "turbo"
      }), " is aware of the file by adding it to task inputs. You can do this two ways:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["对于特定任务：在任务的 ", _jsxs(_components.a, {
            href: "/docs/reference/configuration#inputs",
            children: [_jsx(_components.code, {
              children: "inputs"
            }), " 数组"]
          }), " 中包含该文件："]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "For specific tasks"
          }), ": Include the file in ", _jsxs(_components.a, {
            href: "/docs/reference/configuration#inputs",
            children: ["the ", _jsx(_components.code, {
              children: "inputs"
            }), " array"]
          }), " of the task(s):"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build-for-platforms\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo-cache-key.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["对于所有任务：将文件添加到 ", _jsx(_components.a, {
            href: "/docs/reference/configuration#globaldependencies",
            children: _jsx(_components.code, {
              children: "globalDependencies"
            })
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "For all tasks"
          }), ": Add the file to ", _jsx(_components.a, {
            href: "/docs/reference/configuration#globaldependencies",
            children: _jsx(_components.code, {
              children: "globalDependencies"
            })
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"turbo-cache-key.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ..."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "4-运行-turbo-之前生成文件-generate-the-file-before-running-turbo",
      children: ["4. 运行 ", _jsx(_components.code, {
        children: "turbo"
      }), " 之前生成文件 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥ Generate the file before running ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["最后，你需要确保在运行 ", _jsx(_components.code, {
        children: "turbo"
      }), " 之前运行该脚本。例如："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Last, you'll want to ensure that you run the script before running ", _jsx(_components.code, {
        children: "turbo"
      }), ". For example:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build-for-platforms\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"node ./scripts/create-turbo-cache-key.js && turbo run build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run build"
      }), " 现在将在计算 ", _jsx(_components.code, {
        children: "build"
      }), " 任务的哈希值时考虑 ", _jsx(_components.code, {
        children: "turbo-cache-key.json"
      }), " 的内容。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo run build"
      }), " will now take into account the contents of ", _jsx(_components.code, {
        children: "turbo-cache-key.json"
      }), " when calculating the hash for the ", _jsx(_components.code, {
        children: "build"
      }), " task."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
